export default "__VITE_ASSET__CiQknGWc__"